import axios from "axios";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";
import { SettingReadDto } from "../settings/interface";

export interface NewsItem {
  timestamp: number;
  title: string;
  displayName: string;
  text: string;
}

export type INewsReturn = IAxiosReturn<NewsItem[]>;

/**
 * Loads news from the back end.
 *
 * @param backEndUrl - The backend API base URL for making HTTP requests
 * @returns A promise resolving to `INewsReturn` containing an array of news items on success.
 */
export const loadNews = async (backEndUrl: string): Promise<INewsReturn> => {
  // Get data
  try {
    const response: { data: SettingReadDto } = await axios.get(`${backEndUrl}Settings/News`);
    // Return successful result
    return {
      success: true,
      data: (JSON.parse(response.data.value) as NewsItem[]).sort(
        (a, b) => b.timestamp - a.timestamp,
      ),
    };
  } catch (error: unknown) {
    return processAxiosError("Load news failed", error);
  }
};
